export const OperationKeyValues = (valType) => {
    switch (valType.toUpperCase()) {
        case "INT": case "DOUBLE": case "LONG":
            return ([
                { label: "Is Equal to", value: "EQUAL_TO" },
                { label: "Is Not Equal to", value: "NOT_EQUAL" },
                { label: "Is Greater than", value: "GREATER_THEN" },
                { label: "Is Less than", value: "LESS_THEN" },
                { label: "Is Greater than Equal", value: "GREATER_THEN_EQUAL" },
                { label: "Is Less than Equal", value: "LESS_THEN_EQUAL" },
            ]);

        case "STRING": case "ARRAYOFOBJ": case "SIZEOFARRAY": case "UUID": case "JSON_LIST": case "COLLECTION_OBJECT" : case "COLLECTION_OBJECT_LIST":
            return ([
                { label: "Contains", value: "MATCH_TO" },
                { label: "Does Not Contain", value: "NOT_MATCH_TO" },
                { label: "Start With", value: "MATCH_START" },
                { label: "End With", value: "MATCH_END" },
                { label: "Equal", value: "EQUAL_TO" },
                { label: "Does Not Equal", value: "NOT_EQUAL" },
            ]);

        case "BOOLEAN":

            break;
        // case "ARRAYOFOBJ":

        //     break;
        // case "SIZEOFARRAY":

        //     break;
        // case "UUID":

        //     break;
        // case "JSON_LIST":

        //     break;
        // case "COLLECTION_OBJECT":

        //     break;

        case "ENUM":

            break;
        case "DATE": case "DATETIME":
            return ([
                { label: "Today", value: "EQUAL_TO" },
                { label: "Yesterday", value: "EQUAL_TO" },
                { label: "This Week", value: "IS_BETWEEN" },
                { label: "Last Week", value: "IS_BETWEEN" },
                { label: "Last Two Weeks", value: "IS_BETWEEN" },
                { label: "This Month", value: "IS_BETWEEN" },
                { label: "Last Month", value: "IS_BETWEEN" },
                { label: "Last Two Month", value: "IS_BETWEEN" },
                { label: "Before", value: "LESS_THEN" },
                { label: "After", value: "GREATER_THEN" },
                // { label: "Specific Date", value: "EQUAL_TO" },
                { label: "Custom", value: "IS_BETWEEN" },
            ]);
            break;

        default:
            break;
    }
}